export const formatStorageBytes = (
  bytes?: string | number | null
): string | null => {
  if (bytes === null || bytes === undefined || bytes === "") {
    return null;
  }

  const value = Number(bytes);
  if (!Number.isFinite(value) || value < 0) {
    return null;
  }

  const gb = value / 1024 ** 3;
  if (gb >= 10) {
    return `${Math.round(gb).toLocaleString()} GB`;
  }
  if (gb >= 1) {
    return `${gb.toLocaleString(undefined, { maximumFractionDigits: 1 })} GB`;
  }

  const mb = value / 1024 ** 2;
  if (mb >= 1) {
    return `${Math.round(mb).toLocaleString()} MB`;
  }

  return `${Math.max(Math.round(value / 1024), 1).toLocaleString()} KB`;
};
